import { render, staticRenderFns } from "./GoBackModal.vue?vue&type=template&id=6f3e19e7"
import script from "./GoBackModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GoBackModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports